import React from "react";
import "./styles.css";
import WelcomeImg from "../../assets/img/welcome.png";
import Anchor from "../UI/anchor";
import { calendlyTramy, whatsappTramy } from "../../constants/urls";
import { titleWelcome, subtitleWelcome } from "../../constants/contents";

function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome__info">
        <h1>{titleWelcome}</h1>
        <p>{subtitleWelcome}</p>
        <span>
          <Anchor
            link={whatsappTramy}
            text={"Acceder ahora"}
            background={"#109cf1"}
            color="white"
          />
          <Anchor
            link={calendlyTramy}
            text={"Agendar una demo"}
            color={"#109cf1"}
          />
        </span>
      </div>
      <img src={WelcomeImg} alt="Welcome to Tramy" />
    </div>
  );
}

export default Welcome;
